import { useNavigate, NavigateOptions, NavigateFunction } from 'react-router-dom';

const useAppNavigate = (): NavigateFunction => {
  const navigate = useNavigate();

  return (delta, options?: NavigateOptions) => {
    if (typeof delta === 'number') return navigate(delta);

    if (typeof delta === 'object')
      return navigate(
        {
          ...delta,
          pathname: `${delta}`,
        },
        options,
      );

    return navigate(
      {
        pathname: `${delta}`,
      },
      {
        relative: 'route',
        ...options,
      },
    );
  };
};

export default useAppNavigate;
